import { useState, type FC } from 'react';
import { useCallbackRef } from '../../../../../ReactSharedScripts/hooks/useCallbackRef';
import { getAppElement } from '../../../../../ReactSharedScripts/modules/app/utils';
import { isExpandedInitially } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/utils';
import { setCookie } from '../../../../../ReactSharedScripts/utils/cookie';
import { createProvider } from '../../../../../ReactSharedScripts/utils/createProvider';
import { isUndefined } from '../../../../../ReactSharedScripts/predicates/type';

export type ToolNavigationExpandedContextValue = {
	isExpanded: boolean;
	toggleExpanded: (open?: boolean) => void;
};

const [Provider, useProvider, Context] = createProvider<ToolNavigationExpandedContextValue>({
	contextName: 'ToolNavigationExpandedContext',
	defaultValue: {
		isExpanded: false,
		toggleExpanded: () => {},
	},
});

export const useToolNavigationExpandedProvider = useProvider;
export const ToolNavigationExpandedContext = Context;

export const ToolNavigationExpandedProvider: FC<React.PropsWithChildren> = ({ children }) => {
	const [isExpanded, setIsExpanded] = useState<boolean>(isExpandedInitially());
	const toggleExpanded = useCallbackRef((open: boolean) => {
		if (isUndefined(open)) {
			open = !isExpanded;
		}

		const pageElement = getAppElement();

		if (open) {
			pageElement.classList.add('app--tool-navigation-expanded');
		} else {
			pageElement.classList.remove('app--tool-navigation-expanded');
		}

		setCookie('toolNavigation_isExpandedView', String(open), { days: 100 });
		setIsExpanded(open);
	});

	return (
		<Provider
			value={{
				isExpanded,
				toggleExpanded,
			}}
		>
			{children}
		</Provider>
	);
};
